<template>
  <div :class="['BizHeader', {'BizHeader_open': showCloseBtn, 'BizHeader_fixed': ceil || animationCeil}]">
      <div class="BizHeader-navigation">
        <div>
          <a
            class="BizHeader-logo"
            :href="logoUrl"
            @click.prevent="logoClick(logoUrl, fromSoj)"
          >
            <img class="BizHeader-logo-ajk" src="https://pages.anjukestatic.com/fe/esf/img/cb67f717/ajk_logo@3x.png"/>
          </a>
          <a
            id="header-city"
            class="BizHeader-city"
            :href="cityInfo.url"
            @click.prevent="cityClick(cityInfo, fromSoj)"
          >
            <span class="city-name">{{cityInfo.name}}</span>
            <span class="arrow-wrap">
              <i class="arrow"/>
            </span>
          </a>
        </div>
        <div class="BizHeader-detail">
          <a
            v-for="(item, index) in navList"
            :key="index"
            :href="item.url"
            class="BizHeader-detailItem"
            @click.prevent="navItemClick(item, index, fromSoj)"
          >
            {{ item.surname || item.title}}
          </a>
          <i
            class="BizHeader-expendBtn icon-ec0d"
            v-if="!showCloseBtn"
            @click="handleShowClose"/>
          <i
            v-else
            class="BizHeader-expendBtn icon-ec0e"
            @click="handleShowClose"/>
        </div>
      </div>
      <div
        v-show="showCloseBtn"
        class="BizHeader-slide"
        @click="handleShowClose"
        @touchmove.prevent>
      </div>
    <transition
      name="slide-fade"
      @after-leave="afterLeave"
    >
        <div v-show="showCloseBtn" class="slide-content" @touchmove.prevent>
          <a
            v-for="(item, index) in slideList"
            :key="index"
            class="BizHeader-slideItem"
            :href="item.url"
            @click.prevent="slideItemClick(item, index, fromSoj)"
          >
            <i :class="item.icon || iconMap[item.type]"/>
            <span class="slide-text">{{ item.title }}</span>
          </a>
        </div>
      </transition>
    </div>
</template>
<script>
import { concatSoj } from '../../utils/common/base';

export default {
  name: 'BizHeader',
  props: {
    /**
     *  初始化吸顶
     */
    initCeil: {
      type: Boolean,
      default: () => false,
    },
    /**
     *  点击自动吸顶
     */
    autoCeil: {
      type: Boolean,
      default: () => true,
    },
    /**
     *  logo图对应的url
     */
    logoUrl: {
      type: String,
      required: true,
      default: () => '//m.anjuke.com',
    },
    /**
     *  城市选择对应的url
     */
    cityInfo: {
      type: Object,
      required: true,
      default: () => ({
        name: '上海',
        url: '//m.anjuke.com/cityList/',
      }),
    },
    menuList: { // 所有列表数据，包括导航和隐藏列表
      type: Array,
      required: true,
      default: () => [{
        url: '//m.anjuke.com/xinfang/',
        title: '新房',
        type: 'xf',
      }, {
        url: '//m.anjuke.com/sale/',
        title: '二手房',
        type: 'esf',
      }, {
        url: '//m.anjuke.com/sh/rent/',
        title: '租房',
        type: 'zf',
      },
      {
        url: '//m.anjuke.com/sh/shangye/',
        title: '商铺写字楼',
        icon: 'icon-ec08',
        type: 'spxzl',
      }, {
        url: '//m.anjuke.com/haiwai/list/',
        title: '海外地产',
        icon: 'icon-ec09',
        type: 'hwdc',
      }, {
        url: '//m.anjuke.com/sh/zx/',
        title: '装修',
        icon: 'icon-eca0',
        type: 'zx',
      }, {
        url: '//m.anjuke.com/sh/community/',
        title: '查房价',
        icon: 'icon-ec0a',
        type: 'cfj',
      }, {
        url: '//m.anjuke.com/sh/qa/',
        title: '问答',
        icon: 'icon-ec0b',
        type: 'wd',
      }, {
        url: '//m.anjuke.com/member/home/',
        title: '登录/注册',
        icon: 'icon-ec0c',
        type: 'dlzc',
      },
      ],
      validator(value) {
        return (Object.prototype.toString.call(value) === '[object Array]');
      },
    },
    /**
     *  from码
     */
    fromSoj: {
      type: String,
      default: '',
    },
    /**
     *  点击城市名的回调
     */
    logoClick: {
      type: Function,
      default: (url, fromSoj) => {
        window.location.href = concatSoj(url, fromSoj);
      },
    },
    /**
     *  点击城市名的回调
     */
    cityClick: {
      type: Function,
      default: (cityInfo, fromSoj) => {
        window.location.href = concatSoj(cityInfo.url, fromSoj);
      },
    },
    /**
     *  点击展开或关闭按钮
     */
    expendBtnClick: {
      type: Function,
      default: () => {
        // do nothing
      },
    },
    /**
     *  点击navList中item的回调
     */
    navItemClick: {
      type: Function,
      default: (item, index, fromSoj) => {
        window.location.href = concatSoj(item.url, fromSoj);
      },
    },
    /**
     *  点击slideList中item的回调
     */
    slideItemClick: {
      type: Function,
      default: (item, index, fromSoj) => {
        window.location.href = concatSoj(item.url, fromSoj);
      },
    },
  },
  data() {
    return {
      showCloseBtn: false,
      iconMap: {
        xf: 'icon-eb00',
        esf: 'icon-eafe',
        zf: 'icon-ec71',
        spxzl: 'icon-ec08',
        hwdc: 'icon-ec09',
        zx: 'icon-eca0',
        cfj: 'icon-ec0a',
        wd: 'icon-ec0b',
        dlzc: 'icon-ec0c',
      },
      animationCeil: false,
      navList: [], // 导航数据
      slideList: [], // 隐藏展示数据
    };
  },
  computed: {
    ceil() {
      return this.initCeil || (this.autoCeil && this.showCloseBtn);
    },
  },
  methods: {
    handleShowClose() {
      this.showCloseBtn = !this.showCloseBtn;
      if (this.showCloseBtn) {
        this.animationCeil = true;
      }
      this.expendBtnClick(this.showCloseBtn);
    },
    afterLeave() {
      this.animationCeil = false;
    },
  },
  mounted() {
    const clientWidth = document.body.offsetWidth; // 屏幕宽度
    const el = document.getElementById('header-city').offsetWidth; // header的左半部分宽度
    const navMaxWidth = clientWidth - el - 185; // 导航的最大宽度
    let navListNum; // 导航数量
    let sum = 0;
    let lock = 0;
    this.menuList.forEach((item, index) => {
      if (lock === 1) return;
      if (item.type === 'spxzl') { // type为商铺写字楼外面导航显示名字为商办
        item.surname = '商办'; // eslint-disable-line no-param-reassign
        sum += 2;
      } else {
        sum += item.title.length;
      }
      if ((sum * 15 + (index - 1) * 10) > navMaxWidth) { // 每个字的宽度为15，间隔为10
        lock = 1;
        navListNum = index;
      }
    });
    this.navList = this.menuList.slice(0, navListNum);
    this.slideList = this.menuList.slice(navListNum);
  },

};
</script>
<style src="../../assets/iconfonts.css" scoped></style>
<style scoped>
  .BizHeader {
    position: relative;
    width: 100vw;
  }
  .BizHeader_fixed {
    zoom: 1;
    z-index:1000;
    position: fixed;
    top: 0;
    left: 0;
  }
  .BizHeader a {
    -webkit-tap-highlight-color: transparent;
  }
  .BizHeader-navigation {
    position: relative;
    width: 100vw;
    box-sizing: border-box;
    z-index: 1004;
    background: #fff;
    padding: 0 15px;
    display: -webkit-flex;
    display: flex;
    height: 54px;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
  }
  .BizHeader-logo-ajk {
    width: 84px;
  }
  .BizHeader-logo {
    display: inline-block;
    height: 24px;
    margin-right: 9px;
    vertical-align: text-bottom;
    text-decoration: none;
  }
  .BizHeader-logo i {
    color: #1aad00;
    display: inline-block;
    height: 24px;
    line-height: 24px;
    font-size: 84px;
    overflow: hidden;
  }
  .BizHeader-logo i.icon-eb60:before {
    display: inline-block;
  }
  .BizHeader-city {
    display: inline-block;
    margin-right: 15px;
    font-size: 12px;
    color: #43474D;
    text-decoration: none;
  }
  .BizHeader-city .city-name {
    margin-right: 6px;
  }
  .BizHeader-city .arrow {
    width: 0;
    height: 0;
    border-top: 4px solid #999;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    display: inline-block;
  }
  .BizHeader-city .arrow-wrap {
    position: relative;
    bottom: 2px;
  }
  .BizHeader-detail {
    margin-top: 10px;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: flex-end;
    align-items: center;
  }
  .BizHeader-detail .BizHeader-expendBtn {
    position: relative;
    width: 17px;
    color: #676c73;
    font-size: 13px;
  }
  .BizHeader-detail i {
    margin-left: 15px;
  }
  .BizHeader-expendBtn:before {
    display: block;
    margin-top: -1px;
  }
  .BizHeader-detailItem {
    margin-left: 10px;
    color: #43474D;
    font-size: 15px;
    cursor: pointer;
    text-decoration: none;
  }
  .BizHeader-detailItem:first-of-type {
    margin-left: 0;
  }
  /*隐藏展示部分 start*/
  .BizHeader-slide {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1002;
  }
  .slide-content {
    padding: 0 15px;
    position: absolute;
    z-index: 1003;
    left: 0;
    width: 100vw;
    background: #fff;
    overflow: hidden;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .BizHeader_open .BizHeader-navigation {
    position: absolute;
  }
  .BizHeader_open .slide-content {
    top: 54px;
  }
  .BizHeader-slideItem {
    color: #43474D;
    font-size: 0;
    display: flex;
    line-height: 56px;
    border-bottom: rgba(230,230,230,.5) .5px solid;
    text-decoration: none;
    height: 56px;
    box-sizing: border-box;
  }
  .BizHeader-slideItem i {
    margin: 0 10px 0 5px;
    font-size: 19px;
  }
  .BizHeader-slideItem .slide-text {
    font-size: 16px;
  }
  .BizHeader-slideItem .icon-ec0a {
    font-size: 20px;
  }

  .slide-fade-enter-active, .slide-fade-leave-active {
    transition: all .3s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to{
    transform: translateY(-100%);
  }
  .BizHeader-slideItem .icon-eafe {
    margin-left: 4px;
  }
  .icon-ec71:before {
    font-size: 18px;
  }
  .icon-eafe:before {
    font-size: 20px;
    color: #43474D;
  }
  .icon-eb00:before {
    font-size: 18px;
  }
  /*隐藏展示部分 end*/
</style>
